export const capitalizeAndSwapFB = (string) => {
    if (string === 'facebook') {
        return 'Meta';
    } else {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        } else {
            return '';
        }
    }
};
